import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { Col, Jumbotron, Row } from 'reactstrap';
import { compose, setDisplayName } from 'recompose';
import getClientEnvironment from '../../getClientEnvironment';
import PrivacyInfo from '../About/PrivacyInfo';
import Alerts from '../Alerts';
import { LoggedInUserProps, withLoggedInUser } from '../Login/withLoggedInUser';
import * as siteLogo from '../site-icon-small.svg';
import DemoActivityMap from '../Strava/Demo/DemoActivityMap';
import StravaLoginButton from '../Strava/StravaLoginButton';
import './index.scss';
import withPreloadContent from './withPreloadContent';

const config = getClientEnvironment();

const LoggedInUserMessage = withLoggedInUser(
    ({ loading, error, loggedInUser }: LoggedInUserProps) => {
        if (!loggedInUser && (loading || error)) {
            return null;
        }

        if (loggedInUser) {
            return (
                <>
                    <p className="lead">
                        You are signed in as{' '}
                        <b>{loggedInUser ? loggedInUser.name : ''}</b>.
                    </p>
                    <p className="lead">
                        <NavLink
                            className="btn btn-primary mr-3"
                            to="/activities"
                        >
                            My activities
                        </NavLink>
                        <NavLink to="/examples" className="btn btn-secondary">
                            Examples
                        </NavLink>
                    </p>
                </>
            );
        }

        return (
            <>
                <p className="lead">
                    See some{' '}
                    <NavLink to="/examples">example activities</NavLink>, or
                    click below to connect with your own Strava account.
                </p>

                <StravaLoginButton />
            </>
        );
    }
);

const enhance = compose<LoggedInUserProps, {}>(
    withPreloadContent,
    setDisplayName('HomeScene')
);

const HomeScene = () => (
    <div>
        <Alerts />
        <div className="site-header">
            <Jumbotron>
                <Row>
                    <Col lg="6">
                        <div className="site-header-text">
                            <h1 className="mb-4">
                                <img
                                    alt={`${config.TITLE} logo`}
                                    src={siteLogo}
                                    className="mr-2"
                                />
                                {config.TITLE}
                            </h1>
                            <p className="lead">
                                {config.TITLE} visualises and animates your
                                GPS-tracked Strava activities.
                            </p>
                            <LoggedInUserMessage />
                        </div>
                    </Col>
                </Row>
                <div className="homepage-map activity-map-container">
                    <DemoActivityMap />
                </div>
            </Jumbotron>
        </div>
        <PrivacyInfo />
    </div>
);

export default enhance(HomeScene);



// WEBPACK FOOTER //
// ./src/client/components/Home/index.tsx